import React from "react";
import { Link } from "react-router-dom";
import { Dices, Radio } from "lucide-react";
import { useApp } from "../context/AppContext";
import { Button } from "../components/ui/button";
import MegaHistory from "../components/MegaHistory";

// /slot-bets and /live-casino-bets — same page shell as My Bets, casino rounds (auto-expire after 10 days).
export default function CasinoBets({ category = "slot" }) {
  const { isAuthed } = useApp();
  const live = category === "live";
  const Icon = live ? Radio : Dices;
  const title = live ? "Live Casino Bets" : "Slot Bets";

  if (!isAuthed) {
    return (
      <div className="max-w-2xl mx-auto px-4 py-24 text-center" data-testid={`casino-bets-${category}-guest`}>
        <Icon className="h-10 w-10 mx-auto text-primary mb-4" />
        <h2 className="font-display font-bold text-2xl">Sign in to view your {title.toLowerCase()}</h2>
        <p className="text-muted-foreground mt-2">Your casino rounds from the last 10 days will appear here.</p>
        <Link to="/"><Button className="mt-6 font-semibold">Go Home</Button></Link>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-10" data-testid={`casino-bets-${category}-page`}>
      <div className="flex items-end justify-between mb-5">
        <h1 className="font-display font-extrabold text-3xl">{title}</h1>
        <Link to="/wallet" className="text-xs text-zinc-500 hover:text-white" data-testid="casino-bets-back">← Account</Link>
      </div>
      <MegaHistory category={category} />
    </div>
  );
}
